import { render, staticRenderFns } from "./autoLoginPage.vue?vue&type=template&id=66f730a3"
import script from "./autoLoginPage.vue?vue&type=script&lang=ts"
export * from "./autoLoginPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports